<button class="link-button-css">
    Check Online <span class="material-symbols-outlined" style="font-size: 16px;">launch</span>
</button>